var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3466_5629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5C2.46268 0.5 0 3.01865 0 6.125C0 8.39287 0.772578 9.02627 4.93568 15.1982C5.2087 15.6017 5.79247 15.6017 6.06547 15.1982C10.2266 9.02539 11 8.39258 11 6.125C11 3.01865 8.53646 0.5 5.5 0.5ZM5.5 8.44238C4.23586 8.44238 3.20833 7.39121 3.20833 6.09863C3.20833 4.80606 4.23672 3.75488 5.5 3.75488C6.76328 3.75488 7.79167 4.80606 7.79167 6.09863C7.79167 7.39121 6.76328 8.44238 5.5 8.44238Z",
    fill: "#3D4744"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3466_5629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.5e5bb8635f47701214cffd26015a0f2b.svg";
export { ForwardRef as ReactComponent };